import React, { useEffect, useState } from 'react';
import TherapistAvailabilityWidget from './TherapistAvailabilityWidget';
import { useDispatch, useSelector } from 'react-redux';
import { getStartDateAndTime, getTimeAsPerBlackoutHours, GetUserTimeZone } from '../../utils';
import {
  AvailablilityFilterAndSortSlots,
  convertDateAndTimeForAvailabilityWidget,
  GetTherapistAvailabilityPayload,
  hasMoreThanFourSlots,
  isSameDateForAvailabilityWidget,
} from '../../utils/AvailabilityWidgetUtils';
import {
  getTherapistAvailabilitySearch,
  getTherapistFilters,
} from 'src/redux/services/questionnaireServices';
import { getScheduleSlotStatus } from 'src/redux/services/calenderServices';
import {
  clearModalContent,
  setModalContent,
} from 'src/redux/modules/modalEvent';
import BookTherapistAppointment from '../BookTherapistAppointment/BookTherapistAppointment';
import {
  AvailabilitySlot,
  Choices
} from '../../types/TherapistAvailabilityWidget';
import { TherapistAvailabilityWidgetEnum } from './TherapistAvailabilityWidgetEnum';
import { Typography } from "src/latest/src/components";


type TherapistAvailabilityWidgetMainType = {
  profileId: string | undefined;
  hideTitle?: boolean;
};

const menuType = {
  label: '',
  unique_key: '',
};

const TherapistAvailabilityWidgetMain: React.FC<
  TherapistAvailabilityWidgetMainType
> = ({ profileId, hideTitle }) => {
  const dispatch = useDispatch();
  const { blackoutHours, blackoutDays } = useSelector(
    (state: any) => state?.configuration,
  );
  const startDateAndTime = getTimeAsPerBlackoutHours(
    new Date(),
    blackoutHours,
    blackoutDays,
    '',
  );

  const [clientAgeFilterData, setClientAgeFilterData] = useState<any>([{}]);
  const [insuranceFilterData, setInsuranceFilterData] = useState<any>([{}]);
  const [serviceTypeFilterData, setServiceTypeFilterData] = useState<any>([{}]);
  const [clientAgeMenuData, setClientAgeMenuData] = useState<[Choices]>([
    menuType,
  ]);
  const [insuranceMenuData, setInsuranceMenuData] = useState<[Choices]>([
    menuType,
  ]);
  const [serviceTypeMenuData, setServiceTypeMenuData] = useState<[Choices]>([
    menuType,
  ]);
  const [selectedClientAgeData, setSelectedClientAgeData] = useState<any>([]);
  const [selectedInsuranceData, setSelectedInsuranceData] = useState<any>([]);
  const [selectedServiceTypeData, setSelectedServiceTypeData] = useState<any>(
    [],
  );
  const [toggleAvailableBtn, setToggleAvailableBtn] = useState<boolean>(false);
  const [showMoreSlots, setShowMoreSlots] = useState<boolean>(false);
  const [availableSlotData, setAvailableSlotData] = useState<any>();
  const [therapistSlotData, setTherapistSlotData] = useState<any>();
  const [dropDownDisabled, setDropDownDisabled] = useState<boolean>(false);
  const [toggleShowMoreSlots, setToggleShowMoreSlots] =
    useState<boolean>(false);
  const [formattedTherapistSlotData, setFormattedTherapistSlotData] =
    useState<any>();
  const limit = 10;
  const givenOffset = 0;

  const sliderDateChange = (date: string) => {

    const isStartDate = isSameDateForAvailabilityWidget(date, startDateAndTime);

    getTherapistAvailabilityData(
      JSON.stringify(
        GetTherapistAvailabilityPayload(
          selectedInsuranceData,
          selectedClientAgeData,
          selectedServiceTypeData,
          GetUserTimeZone,
          isStartDate
            ? startDateAndTime
            : convertDateAndTimeForAvailabilityWidget(date),
          profileId,
        ),
      ),
      limit,
      givenOffset,
    );
  };

  useEffect(() => {
    if (
      selectedClientAgeData &&
      selectedClientAgeData?.length > 0 &&
      selectedInsuranceData &&
      selectedInsuranceData?.length > 0 &&
      selectedServiceTypeData &&
      selectedServiceTypeData?.length > 0
    ) {
      setToggleAvailableBtn(true);
    }
  }, [selectedClientAgeData, selectedInsuranceData, selectedServiceTypeData]);

  const getTherapistAvailabilityData = async (
    payload: any,
    limit: number,
    givenOffset: number,
  ) => {
    setDropDownDisabled(true);
    setToggleAvailableBtn(false);
    await getTherapistAvailabilitySearch(payload, limit, givenOffset)
      .then((res: any) => {
        const therapistData =
          res &&
          res?.match_scores &&
          res?.match_scores?.length > 0 &&
          res?.match_scores?.filter(
            (slotData: any) => slotData?.therapist_id === profileId,
          );

        setAvailableSlotData(res);

        if(therapistData && therapistData?.length > 0){
          
          setTherapistSlotData(therapistData);
          const availableFilteredSlots = AvailablilityFilterAndSortSlots(
            res,
            therapistData,
          );

        setFormattedTherapistSlotData(availableFilteredSlots);

        setShowMoreSlots(hasMoreThanFourSlots(availableFilteredSlots));

        }

        setDropDownDisabled(false);

        setToggleAvailableBtn(false);
      })
      .catch(error => {
        console.error('error is ', error);
        setDropDownDisabled(false);
        setToggleAvailableBtn(false);
      });
  };

  const handleShowMoreSlots = () => {
    setToggleShowMoreSlots(!toggleShowMoreSlots);
  };

  useEffect(() => {
    if (profileId) {
      getTherapistFiltersData(profileId);
    }
  }, [profileId]);

  const getTherapistFiltersData = async (therapistId: string) => {
    therapistId &&
      therapistId?.length > 0 &&
      (await getTherapistFilters(therapistId)
        .then(res => {
          const clientAgeFilter =
            res &&
            res?.filters?.length > 0 &&
            res?.filters?.filter(
              (age: any) =>
                age?.filter_key === TherapistAvailabilityWidgetEnum?.ageGroup,
            );

          const insuranceFilter =
            res &&
            res?.filters?.length > 0 &&
            res?.filters?.filter(
              (insurance: any) =>
                insurance?.filter_key ===
                TherapistAvailabilityWidgetEnum?.insurancePlan,
            );

          const serviceTypeFilter =
            res &&
            res?.filters?.length > 0 &&
            res?.filters?.filter(
              (service: any) =>
                service?.filter_key ===
                TherapistAvailabilityWidgetEnum?.serviceType,
            );

          setClientAgeFilterData(clientAgeFilter);

          setInsuranceFilterData(insuranceFilter);

          setServiceTypeFilterData(serviceTypeFilter);

          if (
            clientAgeFilter &&
            clientAgeFilter[0]?.filter_selection_data &&
            clientAgeFilter[0]?.filter_selection_data?.length > 0
          ) {
            setClientAgeMenuData(clientAgeFilter[0]?.filter_selection_data);
          }

          if (
            insuranceFilter &&
            insuranceFilter[0]?.filter_selection_data &&
            insuranceFilter[0]?.filter_selection_data?.length > 0
          ) {
            setInsuranceMenuData(insuranceFilter[0]?.filter_selection_data);
          }

          if (
            serviceTypeFilter &&
            serviceTypeFilter[0]?.filter_selection_data &&
            serviceTypeFilter[0]?.filter_selection_data?.length > 0
          ) {
            setServiceTypeMenuData(serviceTypeFilter[0]?.filter_selection_data);
          }
        })
        .catch(error => {
          console.error('error of therapist data is ', error);
        }));
  };

  const handleAailabilityBtnClick = () => {
    if (
      selectedClientAgeData &&
      selectedClientAgeData?.length > 0 &&
      selectedInsuranceData &&
      selectedInsuranceData?.length > 0 &&
      selectedServiceTypeData &&
      selectedServiceTypeData?.length > 0
    ) {
      getTherapistAvailabilityData(
        JSON.stringify(
          GetTherapistAvailabilityPayload(
            selectedInsuranceData,
            selectedClientAgeData,
            selectedServiceTypeData,
            GetUserTimeZone,
            startDateAndTime,
            profileId,
          ),
        ),
        limit,
        givenOffset,
      );
    }
  };

  const bookAppointmentSlot = (
    slotData: { slot: AvailabilitySlot; date: string },
    therapistAvailableData: any,
  ) => {
    getTherapistAvailableSlotStatus(
      slotData && slotData?.slot?.hash,
      slotData,
      therapistAvailableData,
    );
  };

  const getTherapistAvailableSlotStatus = async (
    hash: string,
    slotData: { slot: AvailabilitySlot; date: string },
    therapistAvailableData: any,
  ) => {
    setDropDownDisabled(true);
    await getScheduleSlotStatus(hash && hash)
      .then((res: any) => {
        if (!res.available_status) {
          setDropDownDisabled(false);
          dispatch(
            setModalContent({
              modalContent: (
                <div>
                  <Typography
                    variant="size-22"
                    className="mb-5 mt-5 slotsnotAvailable-text"
                    color="color-31"
                  >
                    The appointment you selected is no longer
                    <br />
                    available. Please select a different time slot.
                  </Typography>
                </div>
              ),
              isWithCancelButton: false,
              size: 'lg',
              title: 'Oops!',
              onConfirmButtonClick: () => handleTakeMeBack(),
              className: 'check-slot-available',
              confirmButtonLabel: 'Pick Another Time',
            }),
          );
        } else {
          setDropDownDisabled(false);
          dispatch(
            setModalContent({
              modalContent: (
                <BookTherapistAppointment
                  item={therapistAvailableData}
                  slot={slotData}
                  availbleSlotDetails={res}
                  selectedServiceType={selectedServiceTypeData}
                  selectedInsuranceType={selectedInsuranceData}
                  selectedAgeType={selectedClientAgeData}
                />
              ),
              isWithCancelButton: false,
              size: 'lg',
              title: ' Review Appointment Details',
              className: 'book-appointments-match-modal ',
            }),
          );
        }
      })
      .catch((error: Error) => {
        console.error('error is ', error);
      });
  };

  const handleLaterSlot = (laterSlotData: any) => {
    const userTimeZone = GetUserTimeZone();
    const laterSlotDate = getStartDateAndTime(laterSlotData?.later_slot?.slot_start_date_time, userTimeZone);

    getTherapistAvailabilityData(
      JSON.stringify(
        GetTherapistAvailabilityPayload(
          selectedInsuranceData,
          selectedClientAgeData,
          selectedServiceTypeData,
          GetUserTimeZone,
          convertDateAndTimeForAvailabilityWidget(laterSlotDate),
          profileId,
        ),
      ),
      limit,
      givenOffset,
    );
  };

  const handleTakeMeBack = () => {
    dispatch(clearModalContent());
  };

  return (
    <TherapistAvailabilityWidget
      clientAgeFilterData={clientAgeFilterData}
      insuranceFilterData={insuranceFilterData}
      serviceTypeFilterData={serviceTypeFilterData}
      setSelectedClientAgeData={setSelectedClientAgeData}
      setSelectedInsuranceData={setSelectedInsuranceData}
      setSelectedServiceTypeData={setSelectedServiceTypeData}
      clientAgeMenuData={clientAgeMenuData}
      insuranceMenuData={insuranceMenuData}
      serviceTypeMenuData={serviceTypeMenuData}
      handleAailabilityBtnClick={handleAailabilityBtnClick}
      toggleAvailableBtn={toggleAvailableBtn}
      availableSlotData={availableSlotData}
      therapistSlotData={therapistSlotData}
      formattedTherapistSlotData={formattedTherapistSlotData}
      sliderDateChange={sliderDateChange}
      bookAppointmentSlot={bookAppointmentSlot}
      showMoreSlots={showMoreSlots}
      handleShowMoreSlots={handleShowMoreSlots}
      dropDownDisabled={dropDownDisabled}
      toggleShowMoreSlots={toggleShowMoreSlots}
      hideTitle={hideTitle}
      handleLaterSlot={handleLaterSlot}
    />
  );
};

export default TherapistAvailabilityWidgetMain;
